<template>
<div>
    <!-- 顶部时间选择 -->
    <van-row style="margin: 10px" class="rule-top-row">
        <van-col span="5" class="custom-col rule-time-col">
            <van-cell style="display: flex; align-items: center;" v-model="begin_time" @click="changeTime(1)">
                <span class="rule-time-text">{{ begin_time }}</span></van-cell>
            <van-row style="display: flex;justify-content: center;padding-bottom: 5px;">
                <span style="height:4px;">|</span>
            </van-row>

            <van-cell style="display: flex; align-items: center;" v-model="end_time" @click="changeTime(2)"><span class="rule-time-text">{{end_time}}</span></van-cell>
            <van-row style="display: flex;justify-content: center;margin: 5px">
                <van-switch v-model="auto_bid" size="12" @change="changeBid" />
            </van-row>

        </van-col>
        <van-row style="padding: 5px;" type="flex" justify="space-around">
            <van-col span="10">
                <van-cell title="敬请期待" style="color:gray">
                    <template #right-icon>
                        <div style="display: flex; align-items: center;">
                            <van-icon name="plus" />
                        </div>

                    </template>
                </van-cell>
            </van-col>
            <van-col span="10">
                <van-cell title="连锁模式" @click="goLine">
                    <template #right-icon>
                        <div style="display: flex; align-items: center;">
                            <van-icon name="plus" color="blue" />
                        </div>

                    </template>
                </van-cell>
            </van-col>

        </van-row>
        <van-row style="padding: 5px;" type="flex" justify="space-around">
            <van-col span="10">
                <van-cell title="敬请期待" style="color:gray">
                    <template #right-icon>
                        <div style="display: flex; align-items: center;">
                            <van-icon name="plus" />
                        </div>

                    </template>
                </van-cell>
            </van-col>
            <van-col span="10">
                <van-cell title="自定义模式" @click="goCustom">
                    <template #right-icon>
                        <div style="display: flex; align-items: center;">
                            <van-icon name="plus" color="blue" />
                        </div>

                    </template>
                </van-cell>
            </van-col>

        </van-row>
        <!-- <van-col span="8"  style="display: flex;align-items: center;">
            <van-row span="8" class="custom-col">
              
            </van-row>
            <van-row span="8" class="custom-col">
              <van-radio v-model="mode" name="连锁模式">连锁模式</van-radio>
            </van-row>>
            
          </van-col>
          <van-col span="8" style="display: flex;align-items: center;">
            <van-radio v-model="mode" name="杂牌模式">杂牌模式</van-radio>
            <van-radio v-model="mode" name="连锁模式">连锁模式</van-radio>
          </van-col> -->
    </van-row>

    <!-- 模式选择 -->
    <van-row style="margin: 10px">
        <van-search style="width: 100%;" :placeholder="searchHolder[searchType]" v-model="searchText">
            <template #left-icon>
                <span class="custom-text">{{searchTitle[searchType]}}
                    <van-icon style="margin-left: 2px;" name="sort" @click="changeSearchType" /></span>
            </template>
            <template #right-icon>
                <span class="search-text-right" @click="onSearch">搜索</span>
            </template>
        </van-search>
    </van-row>

    <!-- 方案列表 -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-cell-group style="margin: 10px 10px 50px 10px;background-color: transparent;">
        <van-list 
            v-model="loading" 
            :error.sync="error" 
            error-text="请求失败，点击重新加载" 
            :offset="20" 
            @load="onLoad"
            @error-click="refreshData"
            :finished="tableData.length >= total && total > 0"
            finished-text="没有更多数据了"
        >
            <div v-for="(config, index) in tableData" :key="config.id || index" style="padding: 5px; font-size: small;" @click="bidDetail(config)">
                <van-cell :title="config.name" :label="config.type_name" class="cell-with-margin">
                    <template #right-icon>
                        <van-icon name="new-o" size="18px" color="#1989fa" @click.stop="copyConfig(config)" />
                        <van-switch style="margin-left: 16px;" size="12px"
                          v-model="config.statusProxy"
                          @change="val => onConfigSwitchChange(config, val)"
                          @click.stop
                        />
                        <van-icon style="margin-left: 16px;" name="setting" color="pink" @click.stop="editConfig(config)" />
                    </template>
                </van-cell>
            </div>
        </van-list>
    </van-cell-group>
    </van-pull-refresh>
    <van-popup v-model="showBottom" position="bottom">
        <van-datetime-picker v-model="currentTime" type="time" :min-hour="0" :max-hour="23" @confirm="handleConfirm" @cancel="showBottom = false" />
    </van-popup>

</div>
</template>

<script>
import {
    mapActions,
    mapGetters
} from 'vuex';
import Api from '@/api-service'
import {
    Icon,
    PullRefresh
} from 'vant';

export default {
    components: {
        'van-icon': Icon,
        'van-pull-refresh': PullRefresh
    },
    name: "Rule-Detail",
    data() {
        return {
            tableData: [],
            auto_bid: true,

            currentTime: '',
            showBottom: false,
            src: 0,

            begin_time: '00:01',
            end_time: '23:59',

            searchType: 1,
            // 搜索
            searchTitle: {
                1: '影院',
                2: '方案'
            },
            searchHolder: {
                1: '请输入影院名',
                2: '请输入方案名'
            },
            searchText: '', // 搜索内容

            page: 1,
            pageSize: 10,
            total: 0,
            loading: false,
            error: false,
            refreshing: false,

        }
    },
    created() {
        this.initPage();
        this.auto_bid = this.userInfo.auto == 1
        if (this.userInfo.bid_time.length > 0) {
            // 分割字符串
            let arr = this.userInfo.bid_time.split("-"); // 使用 String.prototype.split 方法
            if (arr.length === 2) {
                this.begin_time = arr[0]; // 分割后的第一部分为开始时间
                this.end_time = arr[1]; // 分割后的第二部分为结束时间
            }
        }
    },
    computed: {
        ...mapGetters(['hasGetUserInfo']),
        userInfo() {
            return this.$store.state.user.userInfo;
        },
    },
    methods: {
        // 初始化页面数据
        initPage() {
            this.page = 1;
            this.tableData = [];
            this.loading = false;
            this.error = false;
            this.fetchData();
        },
        
        // 构建请求参数
        buildRequestParams() {
            const data = {
                page: this.page,
                pageSize: this.pageSize,
            };
            
            if (this.searchText.length > 0) {
                switch (this.searchType) {
                    case 1:
                        data.cinema_name = this.searchText;
                        break;
                    case 2:
                        data.name = this.searchText;
                        break;
                }
            }
            
            return data;
        },
        
        // 获取数据
        fetchData() {
            console.log('[fetchData] 开始请求');
            if (this.loading) return; // 防止重复请求
            console.log('[fetchData]22 开始请求');
            this.loading = true;
            this.error = false;
            
            const data = this.buildRequestParams();
            console.log('[fetchData] 请求参数:', data);
            
            Api.getCinemaRuleList(data).then(res => {
                this.loading = false;
                
                if (res && res.list) {
                    const list = res.list.map(item => {
                        const statusNum = Number(item.status);
                        return {
                            ...item,
                            status: statusNum,
                            statusProxy: statusNum === 1 // 新增布尔代理字段
                        }
                    });
                    
                    if (this.page === 1) {
                        // 第一页，直接替换数据
                        this.tableData = list;
                    } else {
                        // 加载更多，追加数据
                        this.tableData = this.tableData.concat(list);
                    }
                    
                    // 更新页码
                    this.page++;
                    this.total = res.total || this.tableData.length;
                    console.log('[fetchData] 当前页:', this.page, '本次返回:', list.length, '累计:', this.tableData.length, 'total:', this.total);
                    
                    // 检查是否还有更多数据
                    if (list.length < this.pageSize) {
                        this.loading = false; // 没有更多数据了
                    }
                } else {
                    console.log('[fetchData] 无数据返回', res);
                }
            }).catch(err => {
                console.error('[fetchData] 获取数据失败:', err);
                this.loading = false;
                this.error = true;
                this.$notify({
                    type: 'danger',
                    message: '获取数据失败，请重试'
                });
            });
        },
        getSetting() {

        },
        setStatus(item) {
            let data = {
                id: item.id,
                status: item.status == 1 ? 2 : 1
            }

            Api.setCinemaRuleStatus(data).then(res => {
                this.$notify({
                    type: 'success',
                    message: '操作成功'
                });
                this.fetchData();
            })
        },
        goBack() {
            this.$router.go(-1);
        },
        status(item) {
            return item.status == 1 ? true : false;
        },
        changeTime(from) {
            console.log(from)
            this.showBottom = true;
            this.src = from;
            if (from == 1) {
                this.currentTime = this.begin_time;
            } else {
                this.currentTime = this.end_time;
            }
        },
        handleConfirm(value) {
            console.log(value);
            if (this.src == 1) {
                this.begin_time = value;
            } else {
                this.end_time = value;
            }
            let data = {
                bid_time: this.begin_time + '-' + this.end_time
            }

            Api.setAutoStatus(data).then(res => {
                this.$notify({
                    type: 'success',
                    message: '设置成功'
                });

                console.log(this.userInfo)

            })
            this.showBottom = false;
        },
        goCustom() {
            this.$router.push({
                path: '/rule/custom',
                query: {
                    type: 4,
                }
            });
        },
        goLine() {
            this.$router.push({
                path: '/rule/line',
                query: {
                    type: 2,
                }
            });
        },
        editConfig(config) {
            let path = '/rule/custom'
            if (config.type == 2) {
                path = '/rule/line'
            }
            this.$router.push({
                path: path,
                query: {
                    id: config.id,
                    type: config.type,
                }
            })
        },
        copyConfig(config) {
            // 复制报价
            let path = '/rule/custom'
            if (config.type == 2) {
                path = '/rule/line'
            }
            this.$router.push({
                path: path,
                query: {
                    id: config.id,
                    type: config.type,
                    copy: 1,
                }
            })
        },
        closeConfig(config, checked) {
            // 关闭报价
            let data = {
                id: config.id,
                status: config.status == 1 ? 2 : 1
            }
            Api.updateConfigStatus(data).then(res => {
                this.$notify({
                    type: 'success',
                    message: '操作成功'
                });
                this.fetchData();
            })
        },
        changeSearchType() {
            if (this.searchType == 1) {
                this.searchType = 2
            } else {
                this.searchType = 1
            }
            // 切换搜索类型时，清空搜索内容并重新加载
            this.searchText = '';
            this.onSearch();
        },
        onSearch() {
            // 重置分页状态并重新加载数据
            this.page = 1;
            this.tableData = [];
            this.loading = false;
            this.error = false;
            this.fetchData();
        },
        changeBid(checked) {
            let data = {
                bid_type: this.auto_bid ? 1 : 2
            }

            Api.setAutoStatus(data).then(res => {
                this.$notify({
                    type: 'success',
                    message: '操作成功'
                });

                console.log(this.userInfo)

            })
        },
        bidDetail(config) {
            this.$router.push({
                path: "/cinema/rule",
                query: {
                    id: config.id,
                    name: config.name
                }
            })
        },
        onLoad() {
            console.log('[onLoad] tableData.length:', this.tableData.length, 'total:', this.total, 'page:', this.page);
            this.loading = false;
            // 检查是否还有更多数据
            if (this.tableData.length >= this.total && this.total > 0) {
                return;
            }
            // 加载更多数据
            this.fetchData();
        },
        onConfigSwitchChange(config, val) {
            const newStatus = val ? 1 : 2;
            Api.updateConfigStatus({ id: config.id, status: newStatus }).then(() => {
                config.status = newStatus;
                config.statusProxy = val;
                this.$notify({ type: 'success', message: '操作成功' });
            }).catch(() => {
                this.$notify({ type: 'danger', message: '操作失败' });
                // 失败时还原
                config.statusProxy = config.status === 1;
            });
        },
        
        // 刷新数据
        refreshData() {
            this.error = false;
            this.initPage();
        },
        
        // 下拉刷新
        onRefresh() {
            this.refreshing = true;
            this.page = 1;
            this.tableData = [];
            this.loading = false;
            this.error = false;
            
            const data = this.buildRequestParams();
            
            Api.getCinemaRuleList(data).then(res => {
                this.refreshing = false;
                
                if (res && res.list) {
                    const list = res.list.map(item => {
                        const statusNum = Number(item.status);
                        return {
                            ...item,
                            status: statusNum,
                            statusProxy: statusNum === 1
                        }
                    });
                    
                    this.tableData = list;
                    this.total = res.total || 0;
                    this.page = 2; // 重置为第二页，为下次加载做准备
                    
                    this.$notify({
                        type: 'success',
                        message: '刷新成功'
                    });
                }
            }).catch(err => {
                console.error('刷新失败:', err);
                this.refreshing = false;
                this.$notify({
                    type: 'danger',
                    message: '刷新失败，请重试'
                });
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.home-wrap {
    height: 100%;
    background-color: #f3f3f3;

    .main-card-wrap {
        background-color: white;
        -moz-box-shadow: 2px 2px 3px #ccc;
        -webkit-box-shadow: 2px 2px 3px #ccc;
        box-shadow: 2px 2px 3px #ccc;

        .left {
            .title {
                font-size: 16px;
            }

            .btn {
                height: 34px;
                width: 120px;
                color: white;
                margin-top: 6px;
                border-radius: 4px;
                background-color: #8565bd;
            }
        }

        .right {
            margin-right: 8px
        }
    }
}

.custom-col {
    border: 1px solid #ccc;
    /* 边框颜色和宽度 */
    border-radius: 8px;
    /* 圆角大小 */
    background-color: white;
    /* 背景色 */
    // display: flex;
    // align-items: center;

    padding: 5px;
    /* 内边距，根据需要调整 */
}

.custom-model {
    border: 1px solid #ccc;
    /* 边框颜色和宽度 */
    border-radius: 8px;
    /* 圆角大小 */
    background-color: #f5f5f5;
    /* 背景色 */
    // display: flex;
    // align-items: center;

    // padding: 5px; /* 内边距，根据需要调整 */
}

/* 调整 van-cell 的高度 */
.custom-col .van-cell {
    height: 30px;
    /* 设置高度，根据需要调整 */
    font-size: 1px;
    // 字体
    /* 调整字体大小，根据需要调整 */
    // background-color: transparent;
}

.elliptical-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    /* 根据需要调整宽度 */
    height: 24px;
    /* 根据需要调整高度 */
    background-color: #f0f0f0;
    /* 背景色 */
    border-radius: 50%;
    /* 椭圆效果 */
    cursor: pointer;
}

/* 覆盖默认的左右图标样式 */
.van-search__left-icon .van-icon,
.van-search__right-icon .van-icon {
    background-color: transparent;
    /* 移除默认图标的背景色 */
    color: inherit;
    /* 继承文字颜色 */
    font-size: 16px;
    /* 根据需要调整字体大小 */
}

.custom-text {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    /* 根据需要调整宽度 */
    height: 100%;
    /* 使高度与搜索框一致 */
    background-color: #f0f0f0;
    /* 背景色 */
    border-radius: 30%;
    /* 椭圆效果 */
    cursor: pointer;
    font-size: 12px;
    /* 根据需要调整字体大小 */
    color: #333;
    /* 文字颜色 */
    user-select: none;
    /* 防止文本被选中 */
}

.search-text-right {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    /* 根据需要调整宽度 */
    height: 100%;
    /* 使高度与搜索框一致 */
    background-color: #f0f0f0;
    /* 背景色 */
    border-radius: 30%;
    /* 椭圆效果 */
    cursor: pointer;
    font-size: 12px;
    /* 根据需要调整字体大小 */
    color: red;
    /* 文字颜色 */
    user-select: none;
    /* 防止文本被选中 */
}

.cell-with-margin {
    display: flex;
    // align-items: center;
    /* 根据需要调整间隔大小 */
}

/* 减小按钮内部左右空白，让文字一行显示 */
.van-cell {
    padding-left: 8px !important;
    padding-right: 8px !important;
}

.van-cell__title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 专门针对模式选择按钮的样式 */
.van-row .van-col .van-cell {
    padding-left: 6px !important;
    padding-right: 6px !important;
    font-size: 13px;
}

.van-row .van-col .van-cell__title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    min-width: 0;
}

/* 时间列字号不小于 12px，小屏下时间列与模式按钮更易点 */
.rule-time-text {
    display: flex;
    justify-content: center;
    font-size: 12px;
}

@media screen and (max-width: 375px) {
    .rule-time-col {
        flex: 0 0 100%;
        max-width: 100%;
    }
    .rule-top-row .van-col {
        margin-bottom: 4px;
    }
}
</style>
